exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".emailDoesNotExistIcon[data-v-31a0cba7],.emailExistsIcon[data-v-31a0cba7],.fetchingIcon[data-v-31a0cba7]{float:right;margin-right:10px;margin-top:-27px;position:relative;z-index:2;cursor:default}.emailInvalid[data-v-31a0cba7]{color:#e0003f;margin-top:5px}.emailExistsIcon[data-v-31a0cba7]{color:#e0003f}.emailExistsText[data-v-31a0cba7]{color:#e0003f;margin-top:5px}.emailDoesNotExistIcon[data-v-31a0cba7]{color:green}", ""]);

// exports
